
import React from 'react'
import moment from 'moment'
import { FormInput, FormSelect } from '@myxplor/forms'
import Grid from '../../../ui/grid'
import MondayDayPicker from './monday-day-picker'
import RegHolderInput from './reg-holder-input'

const ChildDetails = ({readOnly, values, onChange, isDetermination}) => {

  const title = isDetermination ? 'Determination' : 'Certificate'
  const weeksAtRisk = isDetermination ? 52 : 6

  const options = []
  for (let i = 1; i <= weeksAtRisk; i++) {
    options.push({ value: i, label: i + ' Week' })
  }

  const daysSinceStart = values.start_date != null ? moment().diff(moment(values.start_date), 'days') : 0
  const exceptionalRequired = daysSinceStart > 28
  const otherExceptionalReason = values.exceptional_circumstance_reason === 'OTHER'
  const exceptionalOptions = [
    { value: 'BEYOND', label: 'Delay in evidence beyond Provider’s control' },
    { value: 'OTHER', label: 'Other' }
  ]

  return (
    <fieldset>
      <legend>1. Child Details</legend>

      <FormInput
        required={!readOnly}
        label='Child Name'
        name='child_name'
        value={values.name}
        type='text'
        autoFocus={false}
        onChange={onChange}
        htmlInput={{readOnly: true}}
      />
      <RegHolderInput readOnly={readOnly}/>
      <Grid> 
        <MondayDayPicker
          name='start_date'
          label={`Start of ${title}`}
          value={values.start_date}
          onChange={onChange}
          required={!readOnly}
          future={isDetermination}
          readOnly={readOnly}
          past={91}
        />
        
        <FormSelect
          name='weeks_at_risk'
          label={`${title} Length`}
          onChange={onChange}
          value={values.weeks_at_risk}
          placeholder='Please select ...'
          options={options}
          required={!readOnly}
          htmlSelect={{disabled: readOnly}}
        />
        {exceptionalRequired && (
          <FormSelect
            htmlSelect={{ defaultValue: 'BEYOND', disabled: readOnly }}
            label="Exceptional Circumstance Reason"
            name="exceptional_circumstance_reason"
            value={values.exceptional_circumstance_reason}
            defaultValue="BEYOND"
            onChange={onChange}
            placeholder="Please select ..."
            options={exceptionalOptions}
            required={false}
          />
        )}
        {(exceptionalRequired && otherExceptionalReason) && (
          <FormInput
            required={otherExceptionalReason}
            label='Exceptional Circumstance Text'
            name='exceptional_circumstance_text'
            value={values.exceptional_circumstance_text}
            type='text'
            autoFocus={false}
            onChange={onChange}
            htmlSelect={{disabled: readOnly}}
          />
        )}
      </Grid>
    </fieldset>
  )
}

export default ChildDetails



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/child-details.js